'use client';
import React, { createContext, useContext } from 'react';

const GlobalTimestampContext = createContext<number>(Date.now());

export const GlobalTimestampProvider: React.FC<{ value: number; children: any }> = ({ children, value }) => {
    return <GlobalTimestampContext.Provider value={value}>{children}</GlobalTimestampContext.Provider>;
};

// 自定义 Hook
export const useGlobalTimestamp = () => {
    const timestamp = useContext(GlobalTimestampContext);
    return timestamp;
};
